import { render, staticRenderFns } from "./BaseBill.vue?vue&type=template&id=98dae6a0&scoped=true&"
import script from "./BaseBill.vue?vue&type=script&lang=js&"
export * from "./BaseBill.vue?vue&type=script&lang=js&"
import style0 from "./BaseBill.vue?vue&type=style&index=0&id=98dae6a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dae6a0",
  null
  
)

export default component.exports